import { MarketingLabel } from '@shared/generated'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'


interface BadgeProps {
  className?: string;
  data: MarketingLabel;
  size?: 'medium' | 'large';
}

export default function Badge (props: BadgeProps) {
  const { data, className, size = 'medium' } = props
  const imageUrl = data.image?.url as string | undefined

  return (
    <span
      className={cn(styles.root, styles[`_${size}`], className, {
        [styles._image]: !!imageUrl,
      })}
      style={imageUrl ? undefined : {
        backgroundColor: data.optionBackgroundColor as string,
        color: data.optionColor as string,
      }}
    >
      {imageUrl ? (
        <img
          className={styles.root__img}
          src={imageUrl}
          alt={data.title ?? ''}
          loading="lazy"
          fetchPriority="low"
        />
      ) : (
        data.title
      )}
    </span>
  )
}
